import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { AppContext } from '../../application/provider';
import AttendanceService from '../../axios_services/attendance.service';
import Loader from '../Loader/Loader';

const ModalConfiguracionAsistencia = ({ isOpen, onClose }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPerfil, setSelectedPerfil] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [userConfig, setUserConfig] = useState(null);

    const [form, setForm] = useState({
        entrada1_lv: '09:00', salida1_lv: '13:00', entrada2_lv: '14:00', salida2_lv: '18:00',
        has_lunes: false, entrada1_l: '08:00', salida1_l: '12:30', entrada2_l: '', salida2_l: '',
        has_martes: false, entrada1_m: '08:00', salida1_m: '12:30', entrada2_m: '', salida2_m: '',
        has_miercoles: false, entrada1_mi: '08:00', salida1_mi: '12:30', entrada2_mi: '', salida2_mi: '',
        has_jueves: false, entrada1_j: '10:30', salida1_j: '13:00', entrada2_j: '14:00', salida2_j: '16:00',
        has_viernes: false, entrada1_v: '08:00', salida1_v: '12:30', entrada2_v: '', salida2_v: '',
        entrada1_s: '09:00', salida1_s: '13:00',
        tolerancia: 5, tipo_horario: 'LV', tracked: true
    });

    const allProfiles = state.catalogos?.perfiles || [];

    const usersForPerfil = selectedPerfil
        ? (state.user?.personal || []).filter(
            u => String(u.perfil_id) === String(selectedPerfil) && String(u.estado) === '1'
        )
        : [];

    useEffect(() => {
        if (isOpen) {
            setSelectedPerfil('');
            setSelectedUser('');
            setUserConfig(null);
            setForm({
                entrada1_lv: '09:00', salida1_lv: '13:00', entrada2_lv: '14:00', salida2_lv: '18:00',
                has_lunes: false, entrada1_l: '08:00', salida1_l: '12:30', entrada2_l: '', salida2_l: '',
                has_martes: false, entrada1_m: '08:00', salida1_m: '12:30', entrada2_m: '', salida2_m: '',
                has_miercoles: false, entrada1_mi: '08:00', salida1_mi: '12:30', entrada2_mi: '', salida2_mi: '',
                has_jueves: false, entrada1_j: '10:30', salida1_j: '13:00', entrada2_j: '14:00', salida2_j: '16:00',
                has_viernes: false, entrada1_v: '08:00', salida1_v: '12:30', entrada2_v: '', salida2_v: '',
                entrada1_s: '09:00', salida1_s: '13:00',
                tolerancia: 5, tipo_horario: 'LV', tracked: true
            });
        }
    }, [isOpen]);

    const handlePerfilChange = (e) => {
        setSelectedPerfil(e.target.value);
        setSelectedUser('');
        setUserConfig(null);
    };

    const handleUserChange = async (e) => {
        const uid = e.target.value;
        setSelectedUser(uid);
        setUserConfig(null);
        if (!uid) return;

        setIsLoading(true);
        try {
            const resp = await AttendanceService.getConfigs();
            const allConfigs = resp.data?.profile_configs || [];
            const configResp = await AttendanceService.getUsersWithConfig(selectedPerfil);
            const userEntry = (configResp.data || []).find(u => String(u.usuario_id) === String(uid));
            if (userEntry?.config) {
                const c = userEntry.config;
                setForm({
                    entrada1_lv: c.entrada1_lv?.slice(0, 5) || '09:00',
                    salida1_lv: c.salida1_lv?.slice(0, 5) || '13:00',
                    entrada2_lv: c.entrada2_lv?.slice(0, 5) || '14:00',
                    salida2_lv: c.salida2_lv?.slice(0, 5) || '18:00',
                    has_lunes: !!c.entrada1_l, entrada1_l: c.entrada1_l?.slice(0, 5) || '08:00', salida1_l: c.salida1_l?.slice(0, 5) || '12:30', entrada2_l: c.entrada2_l?.slice(0, 5) || '', salida2_l: c.salida2_l?.slice(0, 5) || '',
                    has_martes: !!c.entrada1_m, entrada1_m: c.entrada1_m?.slice(0, 5) || '08:00', salida1_m: c.salida1_m?.slice(0, 5) || '12:30', entrada2_m: c.entrada2_m?.slice(0, 5) || '', salida2_m: c.salida2_m?.slice(0, 5) || '',
                    has_miercoles: !!c.entrada1_mi, entrada1_mi: c.entrada1_mi?.slice(0, 5) || '08:00', salida1_mi: c.salida1_mi?.slice(0, 5) || '12:30', entrada2_mi: c.entrada2_mi?.slice(0, 5) || '', salida2_mi: c.salida2_mi?.slice(0, 5) || '',
                    has_jueves: !!c.entrada1_j, entrada1_j: c.entrada1_j?.slice(0, 5) || '10:30', salida1_j: c.salida1_j?.slice(0, 5) || '13:00', entrada2_j: c.entrada2_j?.slice(0, 5) || '14:00', salida2_j: c.salida2_j?.slice(0, 5) || '16:00',
                    has_viernes: !!c.entrada1_v, entrada1_v: c.entrada1_v?.slice(0, 5) || '08:00', salida1_v: c.salida1_v?.slice(0, 5) || '12:30', entrada2_v: c.entrada2_v?.slice(0, 5) || '', salida2_v: c.salida2_v?.slice(0, 5) || '',
                    entrada1_s: c.entrada1_s?.slice(0, 5) || '09:00',
                    salida1_s: c.salida1_s?.slice(0, 5) || '13:00',
                    tolerancia: c.tolerancia || 5,
                    tipo_horario: c.entrada1_s ? 'LS' : 'LV',
                    tracked: c.tracked !== undefined && c.tracked !== null ? Boolean(Number(c.tracked)) : true
                });
            } else {
                setForm(prev => ({ ...prev, tracked: true }));
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSave = async () => {
        if (!selectedUser) {
            alert('Por favor, seleccione un colaborador.');
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                usuario_id: selectedUser,
                perfil_id: null,
                entrada1_lv: form.entrada1_lv,
                salida1_lv: form.salida1_lv,
                entrada2_lv: form.entrada2_lv,
                salida2_lv: form.salida2_lv,
                entrada1_l: form.has_lunes ? form.entrada1_l : null, salida1_l: form.has_lunes ? form.salida1_l : null, entrada2_l: form.has_lunes ? (form.entrada2_l || null) : null, salida2_l: form.has_lunes ? (form.salida2_l || null) : null,
                entrada1_m: form.has_martes ? form.entrada1_m : null, salida1_m: form.has_martes ? form.salida1_m : null, entrada2_m: form.has_martes ? (form.entrada2_m || null) : null, salida2_m: form.has_martes ? (form.salida2_m || null) : null,
                entrada1_mi: form.has_miercoles ? form.entrada1_mi : null, salida1_mi: form.has_miercoles ? form.salida1_mi : null, entrada2_mi: form.has_miercoles ? (form.entrada2_mi || null) : null, salida2_mi: form.has_miercoles ? (form.salida2_mi || null) : null,
                entrada1_j: form.has_jueves ? form.entrada1_j : null, salida1_j: form.has_jueves ? form.salida1_j : null, entrada2_j: form.has_jueves ? (form.entrada2_j || null) : null, salida2_j: form.has_jueves ? (form.salida2_j || null) : null,
                entrada1_v: form.has_viernes ? form.entrada1_v : null, salida1_v: form.has_viernes ? form.salida1_v : null, entrada2_v: form.has_viernes ? (form.entrada2_v || null) : null, salida2_v: form.has_viernes ? (form.salida2_v || null) : null,
                entrada1_s: form.tipo_horario === 'LS' ? form.entrada1_s : null,
                salida1_s: form.tipo_horario === 'LS' ? form.salida1_s : null,
                tolerancia: form.tolerancia,
                tracked: form.tracked ? 1 : 0,
                fecha_inicio: new Date().toISOString().slice(0, 10)
            };
            await AttendanceService.storeConfig(payload);
            alert('Horario registrado correctamente para el colaborador.');
            onClose();
        } catch (e) {
            console.error(e);
            alert('Error al guardar la configuración.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>CONFIGURAR HORARIO - INDIVIDUAL</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    {isLoading && <Loader />}
                    <Form style={{ padding: '20px' }} onSubmit={(e) => e.preventDefault()}>
                        <div className="mb-4">
                            <Label>Perfil:</Label>
                            <Input type="select" className="form-control" value={selectedPerfil} onChange={handlePerfilChange}>
                                <option value="">Seleccione un Perfil</option>
                                {allProfiles.map(p => <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion}</option>)}
                            </Input>
                        </div>

                        <div className="mb-4">
                            <Label>Colaborador:</Label>
                            <Input type="select" className="form-control" value={selectedUser} onChange={handleUserChange} disabled={!selectedPerfil}>
                                <option value="">Seleccione un Colaborador</option>
                                {usersForPerfil.map(u => <option key={u.usuario_id} value={u.usuario_id}>{u.nombre_completo_usuario}</option>)}
                            </Input>
                        </div>

                        {selectedUser && (
                            <div className="p-3 mb-4 rounded d-flex align-items-center justify-content-between" style={{ backgroundColor: form.tracked ? '#eaf4ff' : '#ffebe9', border: form.tracked ? '1px solid #b8daff' : '1px solid #f5c6cb' }}>
                                <div>
                                    <strong style={{ color: form.tracked ? '#004085' : '#721c24', fontSize: '13px' }}>
                                        {form.tracked ? '✓ CONTROL DE ASISTENCIA: ACTIVO' : '✕ CONTROL DE ASISTENCIA: DESACTIVADO'}
                                    </strong>
                                    <div style={{ fontSize: '12px', color: form.tracked ? '#004085' : '#721c24', marginTop: '2px' }}>
                                        {form.tracked
                                            ? 'Este colaborador aparecerá en el control de asistencias del mes.'
                                            : 'Este colaborador estará EXCLUIDO y no aparecerá en el módulo de asistencias.'}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Input
                                        type="checkbox"
                                        id="tracked_toggle"
                                        name="tracked"
                                        checked={form.tracked}
                                        onChange={handleInput}
                                        style={{ width: '20px', height: '20px', cursor: 'pointer', margin: 0 }}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="mb-4">
                            <Label>Minutos de Tolerancia:</Label>
                            <Input type="number" className="form-control" name="tolerancia" value={form.tolerancia} onChange={handleInput} />
                        </div>

                        <div className="mb-4">
                            <Label>Horario:</Label>
                            <Input type="select" className="form-control" name="tipo_horario" value={form.tipo_horario} onChange={handleInput}>
                                <option value="LV">Lunes - Viernes</option>
                                <option value="LS">Lunes - Sábado</option>
                            </Input>
                        </div>

                        <hr className="my-4" />

                        <div className="mb-4">
                            <Label>Ingreso Turno I:</Label>
                            <Input type="time" className="form-control" name="entrada1_lv" value={form.entrada1_lv} onChange={handleInput} />
                        </div>

                        <div className="mb-4">
                            <Label>Salida Turno I:</Label>
                            <Input type="time" className="form-control" name="salida1_lv" value={form.salida1_lv} onChange={handleInput} />
                        </div>

                        <div className="mb-4">
                            <Label>Ingreso Turno II:</Label>
                            <Input type="time" className="form-control" name="entrada2_lv" value={form.entrada2_lv} onChange={handleInput} />
                        </div>

                        <div className="mb-4">
                            <Label>Salida Turno II:</Label>
                            <Input type="time" className="form-control" name="salida2_lv" value={form.salida2_lv} onChange={handleInput} />
                        </div>

                        <div className="p-3 mb-4 rounded bg-light" style={{ border: '1px solid #dee2e6' }}>
                            <h6 className="font-weight-bold mb-3" style={{ fontSize: '13px', color: '#0549a7' }}>HORARIOS DIFERENCIADOS POR DÍA (OPCIONAL)</h6>
                            <p style={{ fontSize: '12px', color: '#6c757d' }} className="mb-3">
                                Si un día de la semana tiene un horario distinto al general (L-V), marca el día para personalizarlo:
                            </p>
                            
                            {[
                                { key: 'l', label: 'Lunes', hasKey: 'has_lunes' },
                                { key: 'm', label: 'Martes', hasKey: 'has_martes' },
                                { key: 'mi', label: 'Miércoles', hasKey: 'has_miercoles' },
                                { key: 'j', label: 'Jueves', hasKey: 'has_jueves' },
                                { key: 'v', label: 'Viernes', hasKey: 'has_viernes' },
                            ].map(day => (
                                <div key={day.key} className="mb-3 p-3 bg-white rounded" style={{ border: '1px solid #e9ecef' }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <Input
                                            type="checkbox"
                                            id={day.hasKey}
                                            name={day.hasKey}
                                            checked={form[day.hasKey]}
                                            onChange={handleInput}
                                            style={{ width: '16px', height: '16px', marginRight: '8px' }}
                                        />
                                        <Label htmlFor={day.hasKey} className="m-0 font-weight-bold" style={{ cursor: 'pointer', color: '#333' }}>
                                            Personalizar {day.label}
                                        </Label>
                                    </div>

                                    {form[day.hasKey] && (
                                        <Row className="mt-2 pt-2" style={{ borderTop: '1px dashed #dee2e6' }}>
                                            <Col md={3} className="mb-2">
                                                <Label style={{ fontSize: '11px' }}>Ingreso T1:</Label>
                                                <Input type="time" className="form-control form-control-sm" name={`entrada1_${day.key}`} value={form[`entrada1_${day.key}`] || ''} onChange={handleInput} />
                                            </Col>
                                            <Col md={3} className="mb-2">
                                                <Label style={{ fontSize: '11px' }}>Salida T1:</Label>
                                                <Input type="time" className="form-control form-control-sm" name={`salida1_${day.key}`} value={form[`salida1_${day.key}`] || ''} onChange={handleInput} />
                                            </Col>
                                            <Col md={3} className="mb-2">
                                                <Label style={{ fontSize: '11px' }}>Ingreso T2 (opc):</Label>
                                                <Input type="time" className="form-control form-control-sm" name={`entrada2_${day.key}`} value={form[`entrada2_${day.key}`] || ''} onChange={handleInput} />
                                            </Col>
                                            <Col md={3} className="mb-2">
                                                <Label style={{ fontSize: '11px' }}>Salida T2 (opc):</Label>
                                                <Input type="time" className="form-control form-control-sm" name={`salida2_${day.key}`} value={form[`salida2_${day.key}`] || ''} onChange={handleInput} />
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            ))}
                        </div>

                        {form.tipo_horario === 'LS' && (
                            <div className="p-4 rounded bg-light mb-4" style={{ border: '1px solid #dee2e6' }}>
                                <h6 className="font-weight-bold mb-4" style={{ fontSize: '13px', color: '#0549a7' }}>SÁBADO (MEDIO DÍA)</h6>

                                <div className="mb-4">
                                    <Label>Ingreso Sábado:</Label>
                                    <Input
                                        type="time"
                                        className="form-control"
                                        name="entrada1_s"
                                        value={form.entrada1_s}
                                        onChange={handleInput}
                                    />
                                </div>

                                <div className="mb-0">
                                    <Label>Salida Sábado:</Label>
                                    <Input
                                        type="time"
                                        className="form-control"
                                        name="salida1_s"
                                        value={form.salida1_s}
                                        onChange={handleInput}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="button-container mt-2">
                            <Button className="button-custom" onClick={handleSave} disabled={!selectedUser}>
                                REGISTRAR
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalConfiguracionAsistencia;
